import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
  namespaced: true,
  state () {
    return {
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    search ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.database()
        var ref = db.ref('postcode')
        if (payload.match(/^\d{3}-?\d{4}$/)) {
          ref.orderByChild('a0').equalTo(payload.replace(/-/g, '')).once('value', function (snapshot) {
            if (snapshot.exists) {
              var address = null
              snapshot.forEach(function (data) {
                address = data
              })
              resolve(address)
            }
          })
        } else {
          ref.orderByChild('a7').equalTo(payload).once('value', function (snapshot) {
            if (snapshot.exists) {
              var address = null
              snapshot.forEach(function (data) {
                address = data
              })
              resolve(address)
            }
          })
        }
      })
    }
  }
}
